import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const ImgYear15 = (props) => (
  <StaticQuery
    query={graphql`
      query {

        p1: file(relativePath: { eq: "studio/year15/1.jpg" }) {
          childImageSharp {
            fluid(quality: 50) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        p2: file(relativePath: { eq: "studio/year15/2.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          p3: file(relativePath: { eq: "studio/year15/3.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          p4: file(relativePath: { eq: "studio/year15/4.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p5: file(relativePath: { eq: "studio/year15/5.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p6: file(relativePath: { eq: "studio/year15/6.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p7: file(relativePath: { eq: "studio/year15/7.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p8: file(relativePath: { eq: "studio/year15/8.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p9: file(relativePath: { eq: "studio/year15/9.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p10: file(relativePath: { eq: "studio/year15/10.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p11: file(relativePath: { eq: "studio/year15/11.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p12: file(relativePath: { eq: "studio/year15/12.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p13: file(relativePath: { eq: "studio/year15/13.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p14: file(relativePath: { eq: "studio/year15/14.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p15: file(relativePath: { eq: "studio/year15/15.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p16: file(relativePath: { eq: "studio/year15/16.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p17: file(relativePath: { eq: "studio/year15/17.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p18: file(relativePath: { eq: "studio/year15/18.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }


      }
    `}
    render={data => <Img fluid={data[props.image].childImageSharp.fluid} />}
  />
)
export default ImgYear15
